import { ReactElement } from "react"
import { useParams } from "react-router-dom"

import SingleGenDeviceDisplay from "./singleGenDeviceDisplay"
import DataLoadError from "../../components/fallback/dataLoadError"
import SingleDeviceSkeleton from "../../components/loading/skeletons/singleDeviceSkeleton"
import AppPaper from "../../components/surfaces/appPaper"
import { Datasets } from "../../constants/enums"
import useMultiFetcherGetDevice from "../../services/middleware/hooks/useMultiFetcherGetDevice"

interface IDraftGenUrlParams {
    deviceId: string
}

const SingleGenDeviceDraft = (): ReactElement => {
    const { deviceId } = useParams<
        keyof IDraftGenUrlParams
    >() as IDraftGenUrlParams

    const { data, isLoading, isError, mutate } = useMultiFetcherGetDevice(
        deviceId,
        Datasets.TTR_DRAFT
    )
    if (isLoading && !data) {
        return <SingleDeviceSkeleton />
    }
    if (isError) {
        return (
            <AppPaper>
                <DataLoadError />
            </AppPaper>
        )
    }
    if (!data) {
        return (
            <AppPaper>
                <h1>No data</h1>
            </AppPaper>
        )
    }
    return (
        <SingleGenDeviceDisplay
            data={data}
            mutate={mutate}
            isLoading={isLoading}
            isValidating={false}
            isDraft
        />
    )
}

export default SingleGenDeviceDraft
